//style files
import "./index.scss";
import sliderImg from "../../assets/images/slider.png";

const SliderSection = () => {
  return (
    <section>
      <div className="w-full relative" style={{ paddingTop: "98px" }}>
        <img src={sliderImg} alt="sliderImage" className="w-full" />
        <div className="absolute top-32 sm:top-40 md:top-36 lg:top-44 w-full flex justify-center">
          <img
            className="location-pin w-14 sm:w-24 md:w-36 lg:w-48"
            src={require("../../assets/images/location-pin.png")}
            alt="Burada herşey yolunda"
          />
        </div>
      </div>
    </section>
  );
};

export default SliderSection;
